import {
  CARDUI_NAVBARCARD,
  CARDUI_VISIBILITY_IMGALT,
  CARDUI_SELECTED_PROJECT,
  CARDUI_SAVE_PROJECT_COMPLETED,
  CARDUI_SAVE_PROJECT_ERROR,
  CARDUI_SAVE_PROJECT_LOADING,
  CARDUI_SEARCH_ISLOADING,
  CARDUI_COPYPASTE,
} from "../constants";
import {
  chapterContentDataFetchDataSuccess,
  chapterContentAltDataFetchDataSuccess,
  chapterRowsDataFetchDataSuccess,
} from "./ChapterFetchActions";
import {
  reorderIds,
  setFocus,
  handleExpandInput,
  setExpandAll,
  prioritySort,
  setLineSpacing,
  checkWithImage,
  refreshToken,
  escapeQuotes,
} from "../functionUtils";
import gql from "graphql-tag";
import client from "../apolloClient";

export function selectedProjectID(id = -1) {
  return (dispatch) => {
    dispatch({
      type: CARDUI_SELECTED_PROJECT,
      projectId: parseInt(id, 10),
    });
  };
}

export function toggleVisibilityImgAlt(value = null) {
  return (dispatch, getState) => {
    if (value) {
      dispatch({
        type: CARDUI_VISIBILITY_IMGALT,
        visibilityImgAlt: value,
      });
    } else {
      dispatch({
        type: CARDUI_VISIBILITY_IMGALT,
        visibilityImgAlt: !getState().toggleVisibilityImgAlt,
      });
    }
  };
}

// DELETE CARD KB
export function DeleteCard(index) {
  return (dispatch, getState) => {
    let cardArray = getState().chapterContentData.slice();
    const voice_master = cardArray[index].voice_master;

    if (
      index === 0 &&
      cardArray[index + 1] &&
      cardArray[index].row !== cardArray[index + 1].row
    ) {
      for (let i = index; i <= cardArray[cardArray.length - 1].id; i++) {
        if (cardArray[i].row > 0) {
          cardArray[i].row = cardArray[i].row - 1;
        }
      }
      cardArray.splice(index, 1);
      dispatch(deleteRow(index));
    } else if (
      cardArray[index - 1] &&
      cardArray[index].row !== cardArray[index - 1].row &&
      cardArray[index].lemma !== ""
    ) {
      dispatch(deleteRow(cardArray[index].row));
      for (let i = index; i <= cardArray[cardArray.length - 1].id; i++) {
        if (cardArray[i].row > 0) {
          cardArray[i].row = cardArray[i].row - 1;
        }
      }
    } else if (
      cardArray[index - 1] &&
      cardArray[index + 1] &&
      cardArray[index].row !== cardArray[index - 1].row &&
      cardArray[index].row !== cardArray[index + 1].row
    ) {
      dispatch(deleteRow(cardArray[index].row));
      for (let i = index; i <= cardArray[cardArray.length - 1].id; i++) {
        if (cardArray[i].row > 0) {
          cardArray[i].row = cardArray[i].row - 1;
        }
      }
      cardArray.splice(index, 1);
    } else if (
      cardArray[index - 1] &&
      !cardArray[index + 1] &&
      cardArray[index].row !== cardArray[index - 1].row &&
      cardArray[index].lemma === ""
    ) {
      dispatch(deleteRow(cardArray[index].row));
      cardArray.splice(index, 1);
    } else {
      cardArray.splice(index, 1);
    }

    cardArray = reorderIds(cardArray);
    // if (cardArray.length === index) {
    if (index > 0) {
      setFocus(index - 1);
      dispatch(CardUINavbarCard(index - 1));
    } else {
      setFocus(index);
      dispatch(CardUINavbarCard(index));
    }
    dispatch(chapterContentDataFetchDataSuccess(cardArray));
    dispatch(checkImgAlt(voice_master));
  };
}

export function unlinkCard() {
  return (dispatch, getState) => {
    let currentCard = Object.assign({}, getState().CardUINavbarCard);
    let cardArray = getState().chapterContentData.slice();
    let lockStatus = currentCard.codClass === "Verbo" ? "lock" : "unlock";
    let complexLemmaSplit = currentCard.lemma.split(" ");

    let index = getState().projectData.findIndex(
      (x) => x.proj_id === parseInt(getState().selectedProjectID, 10)
    );
    let data = JSON.parse(getState().projectData[index].proj_profile);

    if (complexLemmaSplit.length === 1) {
      return 0;
    }

    for (
      var i = currentCard.id, j = 0;
      i < currentCard.id + complexLemmaSplit.length;
      j++, i++
    ) {
      cardArray.splice(i + 1, 0, {
        id: 0,
        lemma: complexLemmaSplit[j],
        lemmaPrevious: "",
        img: "placeholder.png",
        sinonimi: 0,
        imgAlt: [],
        lock: lockStatus,
        codClass: "Altro",
        complex: "0",
      });
    }
    cardArray.splice(currentCard.id, 1);
    cardArray = reorderIds(cardArray);
    let newFocusId = currentCard.id + complexLemmaSplit.length;
    dispatch(chapterContentDataFetchDataSuccess(cardArray));
    setTimeout(function () {
      cardArray[newFocusId] ? setFocus(newFocusId) : setFocus(newFocusId - 1);
    }, 300);
    // dispatch(chapterContentDataFetchDataSuccess(cardArray))

    i = currentCard.id;
    j = 0;
    let indexTimeOut = i;
    let indexTimeOutArray = j;
    while (i < currentCard.id + complexLemmaSplit.length) {
      setTimeout(() => {
        cardArray = getState().chapterContentData.slice();
        dispatch(
          setImg(
            cardArray,
            indexTimeOut,
            complexLemmaSplit[indexTimeOutArray],
            currentCard.row,
            true,
            data.imgType,
            data.imgStyle,
            data.priorityOrder
          )
        );
        indexTimeOut++;
        indexTimeOutArray++;
      }, j * 200);
      i++;
      j++;
    }
  };
}

export function mergeCard(direction, id = null, lemma = null) {
  return (dispatch, getState) => {
    let currentCard = Object.assign({}, getState().CardUINavbarCard);
    let cardArray = getState().chapterContentData.slice();
    if (direction === "right" && cardArray[currentCard.id + 1]) {
      cardArray[currentCard.id + 1].lemma =
        currentCard.lemma + " " + cardArray[currentCard.id + 1].lemma;
      cardArray[currentCard.id + 1].lock = "lock";
      setTimeout(() => {
        // TODO: verificare se non serve
        // self.handleExpandInput(cardArray[currentCard.id+1])
        handleExpandInput(cardArray[currentCard.id].id);
      }, 0);
      if (
        cardArray[currentCard.id].row !== cardArray[currentCard.id + 1].row &&
        (currentCard.id === 0 ||
          (cardArray[currentCard.id - 1] &&
            cardArray[currentCard.id].row !==
              cardArray[currentCard.id - 1].row))
      ) {
        dispatch(deleteRow(cardArray[currentCard.id].row));
      }
      cardArray.splice(currentCard.id, 1);
      dispatch(CardUINavbarCard(cardArray[currentCard.id]));
    } else if (direction === "left" && cardArray[currentCard.id - 1]) {
      cardArray[currentCard.id - 1].lemma += " " + currentCard.lemma;
      cardArray[currentCard.id - 1].lock = "lock";
      setTimeout(() => {
        handleExpandInput(cardArray[currentCard.id - 1].id);
      }, 0);
      if (
        cardArray[currentCard.id].row !== cardArray[currentCard.id - 1].row &&
        (currentCard.id === cardArray.length - 1 ||
          (cardArray[currentCard.id + 1] &&
            cardArray[currentCard.id].row !==
              cardArray[currentCard.id + 1].row))
      ) {
        dispatch(deleteRow(cardArray[currentCard.id].row));
      }
      cardArray.splice(currentCard.id, 1);
      dispatch(CardUINavbarCard(cardArray[currentCard.id - 1]));
    }
    cardArray = reorderIds(cardArray);
    dispatch(chapterContentDataFetchDataSuccess(cardArray));
    dispatch(checkImgAlt(currentCard.voice_master));

    if (id !== null && lemma) {
      let index = getState().projectData.findIndex(
        (x) => x.proj_id === parseInt(getState().selectedProjectID, 10)
      );
      let data = JSON.parse(getState().projectData[index].proj_profile);
      dispatch(
        setImg(
          cardArray,
          id,
          lemma,
          currentCard.row,
          true,
          data.imgType,
          data.imgStyle,
          data.priorityOrder
        )
      );
    }
    dispatch(handleCheckRows());
    dispatch(adjustCard());
  };
}

export function AddNewBlankCard(index, row) {
  return (dispatch, getState) => {
    let cardArray = getState().chapterContentData.slice();
    let newIndex = index < 0 ? 0 : index;
    cardArray.splice(newIndex, 0, {
      id: index,
      lemma: "",
      lemmaPrevious: "",
      img: "placeholder.png",
      sinonimi: 0,
      // imgAlt: [],
      lock: "unlock",
      codClass: "Altro",
      complex: "0",
      voice_master: "",
      row,
    });
    cardArray = reorderIds(cardArray);
    dispatch(chapterContentDataFetchDataSuccess(cardArray));
    dispatch(adjustCard());
  };
}

export function CardUINavbarCard(value) {
  if (typeof value === "number") {
    return (dispatch, getState) => {
      let cards = getState().chapterContentData.slice();
      dispatch({
        type: CARDUI_NAVBARCARD,
        navbarCard: cards[value],
      });
    };
  } else {
    return (dispatch) => {
      dispatch({
        type: CARDUI_NAVBARCARD,
        navbarCard: value,
      });
    };
  }
}

export function setImg(
  cardArray = null,
  index,
  lemma,
  row,
  NoAuth = null,
  imgType,
  imgStyle,
  priorityOrder
) {
  return (dispatch, getState) => {
    dispatch(CardUIsearchIsLoading(true));

    if (!cardArray || cardArray === null) {
      cardArray = getState().chapterContentData.slice();
    }

    // Create param for preload query
    let projId = getState().selectedProjectID;
    let indexProjArray = getState().projectData.findIndex(
      (item) => projId === item.proj_id
    );

    // Assemble the query
    lemma = lemma.toLowerCase();
    lemma = lemma.split("\\").join("");
    lemma = lemma.split('"').join('\\"');

    let queryFulltext = `
      arasaac_caa_t_fulltext(where: {voice_master: {_ilike: "${lemma}"}}) {
        voice_master
        voice_human
        idclass
        lexical_expr
        headword {
          xref {
            symbol {
              imgcolor
              symbol_sign
              idstyle
            }
          }
        }
      }
    `;

    // let where;
    const {
      global,
      preload_community,
      preload_private,
      preload_team,
    } = JSON.parse(
      getState().projectData[indexProjArray].proj_profile
    ).queryParams;
    const userId = getState().user.id;

    // // team = FALSE && staff = FALSE
    // if (!preload_team && !preload_community) {
    //   if (preload_private) {
    //     where = {
    //       _and: [
    //         { voice_master: { _ilike: lemma } },
    //         { created_by: { _eq: userId } },
    //         { type_img: { _in: [0, 1] } },
    //       ],
    //     };
    //   } else {
    //     where = {
    //       _and: [
    //         { voice_master: { _ilike: lemma } },
    //         { created_by: { _neq: userId } },
    //       ],
    //     };
    //   }
    // }

    // // team = FALSE && staff = TRUE
    // if (!preload_team && preload_community) {
    //   if (preload_private) {
    //     where = {
    //       _or: [
    //         {
    //           _and: [
    //             { voice_master: { _ilike: lemma } },
    //             { created_by: { _eq: userId } },
    //             { type_img: { _in: [0, 1, 2] } },
    //           ],
    //           _and: [
    //             { voice_master: { _ilike: lemma } },
    //             { created_by: { _neq: userId } },
    //             { type_img: { _eq: 2 } },
    //           ],
    //         },
    //       ],
    //     };
    //   } else {
    //     where = {
    //       _and: [
    //         { voice_master: { _ilike: lemma } },
    //         { type_img: { _eq: 2 } },
    //         { created_by: { _neq: userId } },
    //       ],
    //     };
    //   }
    // }

    // // team = TRUE && staff = FALSE
    // if (preload_team && !preload_community) {
    //   if (preload_private) {
    //     where = {
    //       _or: [
    //         {
    //           _and: [
    //             { voice_master: { _ilike: lemma } },
    //             { created_by: { _eq: userId } },
    //             { type_img: { _in: [0, 1, 3] } },
    //           ],
    //           _and: [
    //             { voice_master: { _ilike: lemma } },
    //             { created_by: { _neq: userId } },
    //             { type_img: { _eq: 3 } },
    //           ],
    //         },
    //       ],
    //     };
    //   } else {
    //     where = {
    //       _and: [
    //         { voice_master: { _ilike: lemma } },
    //         { type_img: { _eq: 3 } },
    //         { created_by: { _neq: userId } },
    //       ],
    //     };
    //   }
    // }

    // // team = TRUE && staff = TRUE
    // if (preload_team && preload_community) {
    //   if (preload_private) {
    //     where = {
    //       _or: [
    //         {
    //           _and: [
    //             { voice_master: { _ilike: lemma } },
    //             { type_img: { _in: [2, 3] } },
    //           ],
    //         },
    //         {
    //           _and: [
    //             { voice_master: { _ilike: lemma } },
    //             { created_by: { _eq: userId } },
    //             { type_img: { _in: [0, 1] } },
    //           ],
    //         },
    //       ],
    //     };
    //   } else {
    //     where = {
    //       _and: [
    //         { voice_master: { _ilike: lemma } },
    //         { type_img: { _in: [2, 3] } },
    //         { created_by: { _neq: userId } },
    //       ],
    //     };
    //   }
    // }

    // STATIC WHERE
    const teamId = getState().filterValue;
    let optionWhere = [];
    const private_where = {
      _and: [{ created_by: { _eq: userId } }, { type_img: { _in: [0, 1] } }],
    };
    const staff_where = { type_img: { _eq: 3 } };
    const team_where = {
      _and: [
        // { idteam: { _eq: teamId } },
        { type_img: { _eq: 2 } },
        { share_team: { _contains: teamId } },
      ],
    };

    // BUILT THE OPTIONWHERE
    if (preload_private) {
      optionWhere.push(private_where);
    }
    if (preload_team) {
      optionWhere.push(team_where);
    }
    if (preload_community) {
      optionWhere.push(staff_where);
    }

    // BUILD THE FINAL WHERE
    let where = {
      _and: [{ voice_master: { _ilike: lemma } }],
    };
    const optionsCheck = [preload_private, preload_team, preload_community];
    if (optionsCheck.filter((item) => item === true).length > 1) {
      where._and.push({ _or: optionWhere });
    } else {
      where._and.push(optionWhere[0]);
    }

    let queryPreload = `
    simcaa_t_custom_preload_headword(where: $where) {
      voice_master
      voice_human
      with_image
      symbol_sign
      lexical_expr
      imgcolor
      idstyle
    }
    `;

    // let query = global
    //   ? gql`query getLemma($where: simcaa_t_custom_preload_headword_bool_exp){
    //   ${queryFulltext}
    //   ${queryPreload}
    // }`
    //   : gql`{
    //   ${queryPreload}
    // }`;

    const preload =
      optionsCheck.filter((item) => item === true).length > 0 ? true : false;
    queryFulltext = global ? queryFulltext : "";
    queryPreload = where._and[1] ? queryPreload : "";
    let query;
    if (global && preload) {
      query = gql`query getLemma($where: simcaa_t_custom_preload_headword_bool_exp){
        ${queryFulltext}
        ${queryPreload}
      }`;
    } else if (global && !preload) {
      query = gql`{
        ${queryFulltext}
      }`;
    } else if (!global && preload) {
      query = gql`query getLemma($where: simcaa_t_custom_preload_headword_bool_exp){
        ${queryPreload}
      }`;
    }

    let catchVar = (error) => {
      cardArray = getState().chapterContentData.slice();
      cardArray[index].lemma = lemma;
      cardArray[index].sinonimi = 0;
      cardArray[index].img = "placeholder.png";
      cardArray[index].row = row;
      cardArray[index].voice_master = lemma;
      dispatch(chapterContentDataFetchDataSuccess(cardArray));
      dispatch(CardUIsearchIsLoading(false));
    };

    let thenVar = (data) => {
      dispatch(CardUIsearchIsLoading(false));

      let newDataSorting = data.data.arasaac_caa_t_fulltext
        ? data.data.arasaac_caa_t_fulltext
        : [];
      let imgAltQuery2 = data.data.simcaa_t_custom_preload_headword
        ? data.data.simcaa_t_custom_preload_headword
        : [];

      newDataSorting = newDataSorting
        .map((word) =>
          word.headword.xref.map((xref) => ({
            voice_master: word.voice_master,
            voice_human: word.voice_human,
            symbol_sign: xref.symbol.symbol_sign,
            idclass: word.idclass,
            lexical_expr: word.lexical_expr,
            imgcolor: xref.symbol.imgcolor,
            idstyle: xref.symbol.idstyle,
          }))
        )
        .flat();

      // Ordina l'cardArray
      let completeOrderedArray;
      if (newDataSorting.length > 0) {
        completeOrderedArray = prioritySort(
          newDataSorting,
          lemma,
          imgType,
          imgStyle,
          priorityOrder
        );
      } else {
        completeOrderedArray = prioritySort(
          imgAltQuery2,
          lemma,
          imgType,
          imgStyle,
          priorityOrder
        );
      }

      if (
        typeof completeOrderedArray !== "undefined" &&
        completeOrderedArray.length > 0
      ) {
        // Identifica la classe del lemma
        switch (completeOrderedArray[0].idclass) {
          case 2:
            cardArray[index].codClass = "Aggettivo";
            break;
          case 3:
            cardArray[index].codClass = "Articolo";
            break;
          case 4:
            cardArray[index].codClass = "Avverbio";
            break;
          case 5:
            cardArray[index].codClass = "Congiunzione";
            break;
          case 10:
            cardArray[index].codClass = "Interiezione";
            break;
          case 14:
            cardArray[index].codClass = "Pronome";
            break;
          case 16:
            cardArray[index].codClass = "Preposizione";
            break;
          case 17:
            cardArray[index].codClass = "Sostantivo";
            break;
          case 20:
            cardArray[index].codClass = "Verbo";
            break;
          case 27:
            cardArray[index].codClass = "Altro";
            break;
          default:
            break;
        }
        cardArray[index].lemmaPrevious = cardArray[index].lemma;
        cardArray[index].sinonimi = completeOrderedArray.length;
        cardArray[index].imgAlt = [];
        cardArray[index].complex = completeOrderedArray[0].lexical_expr;
        cardArray[index].row = row;
        cardArray[index].custom = checkWithImage(completeOrderedArray[0]);

        if (completeOrderedArray[0].voice_human === cardArray[index].lemma) {
          cardArray[index].img = completeOrderedArray[0].symbol_sign;
          // cardArray[index].lemma = completeOrderedArray[0].voice_human;
        } else {
          dispatch(toggleVisibilityImgAlt(true));
        }

        for (let i = 0; i < completeOrderedArray.length; i++) {
          cardArray[index].imgAlt.splice(i, 0, {
            voice_human: completeOrderedArray[i].voice_human,
            voice_master: completeOrderedArray[i].voice_master,
            img: completeOrderedArray[i].symbol_sign,
            complex: completeOrderedArray[i].lexical_expr,
            custom: checkWithImage(completeOrderedArray[i]),
          });
        }

        // accodo le img della seconda query
        // TODO: vedere meglio con ordinamento
        if (newDataSorting.length > 0 && imgAltQuery2.length > 0) {
          for (let i = 0; i < imgAltQuery2.length; i++) {
            cardArray[index].imgAlt.splice(
              i + cardArray[index].imgAlt.length,
              0,
              {
                voice_human: imgAltQuery2[i].voice_human,
                voice_master: imgAltQuery2[i].voice_master,
                img: imgAltQuery2[i].symbol_sign,
                complex: imgAltQuery2[i].lexical_expr,
                custom: checkWithImage(imgAltQuery2[i]),
              }
            );
          }
        }
      } else {
        // cardArray[index].lemma = lemma;
        cardArray[index].sinonimi = 0;
        cardArray[index].img = "placeholder.png";
        cardArray[index].row = row;
      }

      let finalCurrentCard = Object.assign({}, cardArray[index]);
      finalCurrentCard.voice_master = lemma;
      let updatedCardArray = getState().chapterContentData.slice();
      updatedCardArray[index] = Object.assign({}, finalCurrentCard);

      updatedCardArray.every((item) => {
        delete item.imgAlt;
        return item;
      });

      dispatch(setComplexVerbs(cardArray[index]));
      dispatch(adjustCard());
      dispatch(composeCardAlt(cardArray[index].imgAlt));
      dispatch(handleCheckRows(updatedCardArray));
      dispatch(CardUINavbarCard(index));
      if (cardArray[index].voice_master !== "") {
        dispatch(checkImgAlt(cardArray[index].voice_master));
      }
    };

    if (preload) {
      client
        .query({ query, variables: { where } })
        .then(thenVar)
        .catch(catchVar);
    } else {
      client.query({ query }).then(thenVar).catch(catchVar);
    }
  };
}

export function setComplexVerbs() {
  return (dispatch, getState) => {
    setTimeout(function () {
      let currentCard = Object.assign({}, getState().CardUINavbarCard);
      let localCards = getState().chapterContentData.slice();
      let previousId = currentCard.id - 1;
      if (
        previousId > -1 &&
        localCards[previousId].codClass === "Verbo" &&
        currentCard.codClass === "Verbo" &&
        localCards[previousId].lock === "unlock"
      ) {
        let complexLemma =
          localCards[previousId].lemma + " " + currentCard.lemma;

        const query = gql`
          {
            arasaac_caa_t_fulltext(
              where: { voice_master: { _ilike: "${complexLemma}" } }
            ) {
              voice_master
              voice_human
            }
          }
        `;

        client
          .query({ query })
          .then((data) => {
            if (data.data.arasaac_caa_t_fulltext.length > 0) {
              dispatch(CardUINavbarCard(localCards[currentCard.id]));
              dispatch(
                mergeCard(
                  "left",
                  previousId,
                  data.data.arasaac_caa_t_fulltext[0].voice_human
                )
              );
              setFocus(currentCard.id);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }, 100);
  };
}

export function setNewImg(event, imgAlt) {
  return (dispatch, getState) => {
    let currentCard = Object.assign({}, getState().CardUINavbarCard);
    let localCards = getState().chapterContentData.slice();
    localCards[currentCard.id].img = imgAlt.img;
    localCards[currentCard.id].lemma =
      localCards[currentCard.id].lemma.toUpperCase() ===
      imgAlt.voice_human.toUpperCase()
        ? localCards[currentCard.id].lemma
        : imgAlt.voice_human;
    localCards[currentCard.id].complex = imgAlt.complex;
    localCards[currentCard.id].custom = imgAlt.custom;
    let complexLemmaSplit = localCards[currentCard.id].lemma.split(" ");
    let cont = 0;
    if (localCards[currentCard.id + complexLemmaSplit.length - 1]) {
      for (let i = 1; i < complexLemmaSplit.length; i++) {
        currentCard.id++;
        if (localCards[currentCard.id].lemma === complexLemmaSplit[i]) {
          cont++;
        }
      }
    }
    currentCard = Object.assign({}, getState().CardUINavbarCard);
    if (cont === complexLemmaSplit.length - 1) {
      localCards.splice(currentCard.id + 1, cont);
    }
    localCards = reorderIds(localCards);
    dispatch(CardUINavbarCard(currentCard.id));
    dispatch(adjustCard());
    dispatch(chapterContentDataFetchDataSuccess(localCards));
    if (cont > 0) {
      complexLemmaSplit.slice(1).forEach((item) => {
        dispatch(checkImgAlt(item));
      });
    }
    dispatch(toggleVisibilityImgAlt(false));
  };
}

export function blockCard() {
  return (dispatch, getState) => {
    let currentCard = Object.assign({}, getState().CardUINavbarCard);
    let localCards = getState().chapterContentData.slice();
    localCards[currentCard.id].lock === "lock"
      ? (localCards[currentCard.id].lock = "unlock")
      : (localCards[currentCard.id].lock = "lock");
    localCards[currentCard.id].lemma = localCards[currentCard.id].lemma.trim();
    dispatch(chapterContentDataFetchDataSuccess(localCards));
    dispatch(CardUINavbarCard(currentCard.id));
  };
}

export function copyCard() {
  return (dispatch, getState) => {
    let card = Object.assign({}, getState().CardUINavbarCard);
    dispatch({
      type: CARDUI_COPYPASTE,
      card,
    });
  };
}

export function pasteCard() {
  return (dispatch, getState) => {
    let navbarCard = Object.assign({}, getState().CardUINavbarCard);
    let cardToPaste = Object.assign({}, getState().CardUIcopyPaste);
    if (cardToPaste && Object.keys(cardToPaste).length > 0) {
      let localCards = getState().chapterContentData.slice();
      cardToPaste.row = navbarCard.row;
      localCards.splice(navbarCard.id + 1, 0, cardToPaste);
      localCards = reorderIds(localCards);
      dispatch(chapterContentDataFetchDataSuccess(localCards));
      dispatch(adjustCard());
    }
  };
}

export function searchLemma() {
  return (dispatch, getState) => {
    let currentCard = Object.assign({}, getState().CardUINavbarCard);
    let localCards = getState().chapterContentData.slice();

    let index = getState().projectData.findIndex(
      (x) => x.proj_id === parseInt(getState().selectedProjectID, 10)
    );
    let data = JSON.parse(getState().projectData[index].proj_profile);

    dispatch(
      setImg(
        localCards,
        currentCard.id,
        currentCard.lemma,
        currentCard.row,
        true,
        data.imgType,
        data.imgStyle,
        data.priorityOrder
      )
    );
  };
}

// DELETE CARD BUTTON
export function deleteCard() {
  return (dispatch, getState) => {
    let localCards = getState().chapterContentData.slice();
    let currentCard = Object.assign({}, getState().CardUINavbarCard);
    const voice_master = currentCard.voice_master;
    let index = localCards[currentCard.id].id;
    if (localCards.length > 1) {
      if (
        localCards[index - 1] &&
        localCards[index - 1].row !== localCards[index].row &&
        localCards[index + 1] &&
        localCards[index + 1].row !== localCards[index].row
      ) {
        dispatch(deleteRow(localCards[index].row));
      }
      if (
        localCards[index - 1] &&
        localCards[index - 1].row !== localCards[index].row &&
        !localCards[index + 1]
      ) {
        dispatch(deleteRow(localCards[index].row));
      }
      if (
        !localCards[index - 1] &&
        localCards[index + 1] &&
        localCards[index + 1].row !== localCards[index].row
      ) {
        dispatch(deleteRow(localCards[index].row));
      }
      localCards.splice(index, 1);
      localCards = reorderIds(localCards);
      index > 0 ? setFocus(index - 1) : setFocus(index);
      index > 0
        ? dispatch(CardUINavbarCard(index - 1))
        : dispatch(CardUINavbarCard(index));
    }
    dispatch(adjustCard());
    dispatch(handleCheckRows(localCards));
    dispatch(checkImgAlt(voice_master));
  };
}

export function jumpRow() {
  return (dispatch, getState) => {
    let localCards = getState().chapterContentData.slice();
    let currentCard = Object.assign({}, getState().CardUINavbarCard);
    if (currentCard.id === localCards.length - 1 && currentCard.lemma !== "") {
      dispatch(AddNewBlankCard(currentCard.id + 1, currentCard.row + 1));
      dispatch(addNewRow(currentCard.row + 1, "new_line"));
    } else if (
      currentCard.lemma !== "" &&
      !(
        localCards[currentCard.id + 1].lemma === "" &&
        localCards[currentCard.id].row !== localCards[currentCard.id + 1].row
      )
    ) {
      if (
        localCards[currentCard.id].row !== localCards[currentCard.id + 1].row &&
        localCards[currentCard.id + 1].lemma !== ""
      ) {
        dispatch(AddNewBlankCard(currentCard.id + 1, currentCard.row));
      }
      localCards = getState().chapterContentData.slice();

      for (let i = currentCard.id + 1; i < localCards.length; i++) {
        localCards[i].row++;
      }

      dispatch(adjustCard());
      dispatch(chapterContentDataFetchDataSuccess(localCards));
      dispatch(addNewRow(currentCard.row + 1, "new_line"));
    }
  };
}

export function composeCardAlt(imagesAlt) {
  return (dispatch, getState) => {
    let localCardAlt = getState().chapterContentAltData.slice();
    let uniqueCurrentAlt = localCardAlt.concat(imagesAlt);
    uniqueCurrentAlt = uniqueCurrentAlt.filter(
      (item, index, self) =>
        self.findIndex(
          (elem) =>
            elem.img === item.img && elem.voice_human === item.voice_human
        ) === index
    );
    dispatch(chapterContentAltDataFetchDataSuccess(uniqueCurrentAlt));
  };
}

export function checkImgAlt(voice_master) {
  return (dispatch, getState) => {
    let localCards = getState().chapterContentData.slice();
    let localCardAlt = getState().chapterContentAltData.slice();
    const containAlt = localCards.findIndex(
      (item) => item.voice_master === voice_master
    );
    if (containAlt < 0) {
      localCardAlt = localCardAlt.filter(
        (item) => item.voice_master !== voice_master
      );
      dispatch(chapterContentAltDataFetchDataSuccess(localCardAlt));
    }
  };
}

export function handleCheckRows(cardArray = null) {
  return (dispatch, getState) => {
    if (cardArray === null) {
      cardArray = getState().chapterContentData.slice();
    }
    for (let i = 0; i < cardArray.length - 1; i++) {
      if (cardArray[i + 1].row - cardArray[i].row > 1) {
        for (let j = i + 1; j < cardArray.length; j++) {
          if (cardArray[j].row > 0) {
            cardArray[j].row--;
          }
        }
      }
    }
    if (cardArray[0].row !== 0) {
      let delta = 0 - cardArray[0].row;
      for (let i = 0; i < cardArray.length; i++) {
        cardArray[i].row += delta;
      }
    }
    dispatch(chapterContentDataFetchDataSuccess(cardArray));
  };
}

// Delete void card (no lemma)
export function clearCard(cardArray = null) {
  return (dispatch, getState) => {
    if (cardArray === null) {
      cardArray = getState().chapterContentData.slice();
    }

    let idToDelete = [],
      rowToDelete = [];
    for (let i = 0; i < cardArray.length; i++) {
      if (!cardArray[i].lemma) {
        if (
          cardArray[i - 1] &&
          cardArray[i - 1].row !== cardArray[i].row &&
          cardArray[i + 1] &&
          cardArray[i + 1].row !== cardArray[i].row
        ) {
          rowToDelete.push(cardArray[i].row);
        }
        if (
          cardArray[i - 1] &&
          cardArray[i - 1].row !== cardArray[i].row &&
          !cardArray[i + 1]
        ) {
          rowToDelete.push(cardArray[i].row);
        }
        if (
          !cardArray[i - 1] &&
          cardArray[i + 1] &&
          cardArray[i + 1].row !== cardArray[i].row
        ) {
          rowToDelete.push(cardArray[i].row);
        }
        idToDelete.push(i);
      }
    }

    for (let i = idToDelete.length - 1; i >= 0; i--) {
      cardArray.splice(idToDelete[i], 1);
    }

    for (let i = rowToDelete.length - 1; i >= 0; i--) {
      dispatch(deleteRow(rowToDelete[i]));
    }

    cardArray = reorderIds(cardArray);
    dispatch(handleCheckRows(cardArray));
    dispatch(adjustCard());
  };
}

export function saveProject(chapterId, doRefresh = null) {
  return (dispatch, getState) => {
    dispatch(CardUIsaveIsCompleted(false));
    dispatch(CardUIsaveHasErrored(false));
    dispatch(CardUIsaveIsLoading(true));
    dispatch(clearCard());

    // Mini fix for the row problem in edit
    const unescapedContent = getState().chapterContentData.slice();
    const unescapedRow = getState().chapterRowsData.slice();
    const lastCardRow = unescapedContent[unescapedContent.length - 1].row;

    if (lastCardRow >= unescapedRow.length) {
      for (let i = 1; i <= lastCardRow - (unescapedRow.length - 1); i++) {
        dispatch(addNewRow(unescapedRow.length + i, "new_line"));
      }
    }

    let chapt_content = getState().chapterContentData.slice();
    chapt_content = chapt_content.map((item) => {
      item.lemma = item.lemma.split("\\").join("");
      item.voice_master = item.voice_master.split("\\").join("");
      item.lemmaPrevious = item.lemmaPrevious.split("\\").join("");
      return item;
    });
    let chapt_content_alt = getState().chapterContentAltData.slice();
    let chapt_row = getState().chapterRowsData.slice();

    chapt_row[0].page = false;
    // chapt_row = escapeQuotes(chapt_row);
    // chapt_content = escapeQuotes(chapt_content);
    // chapt_content_alt = escapeQuotes(chapt_content_alt);

    // const mutation = gql`
    //   mutation saveChapter {
    //     update_simcaa_t_projects_chapt(
    //       where: { id: { _eq: ${chapterId} } }
    //       _set: { chapt_content: "${chapt_content}", chapt_row: "${chapt_row}" }
    //     ) {
    //       affected_rows
    //     }
    //   }
    // `;
    let chapts = getState().chapterData.slice();
    const chapt = chapts.filter((item) => item.id === +chapterId)[0];
    const contentId = chapt.contentId;
    const contentAltId = chapt.contentAltId;
    const rowId = chapt.rowId;
    const variables = {
      edit: chapt_content,
      row: chapt_row,
      img: chapt_content_alt,
    };
    const mutation = gql`
      mutation saveChapter($edit: json, $row: json, $img: json) {
        update_simcaa_t_projects_chapt_edit(
            where: { caa_chapt_id: { _eq: ${contentId} } }
            _set: { chapt_content: $edit }
          ) {
          affected_rows
        }
        update_simcaa_t_projects_chapt_editrow(
          where: { caa_chapt_id: { _eq: ${rowId} } }
          _set: { chapt_row: $row }
        ) {
          affected_rows
        }
        update_simcaa_t_projects_chapt_img(
          where: { caa_chapt_id: { _eq: ${contentAltId} } }
          _set: { chapt_image_alt: $img }
        ) {
          affected_rows
        }
      }
    `;

    client.mutate({ mutation, variables }).then((data) => {
      if (data.data) {
        dispatch(CardUIsaveIsCompleted(true));
        dispatch(CardUIsaveHasErrored(false));
        dispatch(CardUIsaveIsLoading(false));
      } else {
        dispatch(CardUIsaveIsCompleted(false));
        dispatch(CardUIsaveHasErrored(true));
        dispatch(CardUIsaveIsLoading(false));
      }
    });
    // .catch(error => {
    //   dispatch(CardUIsaveHasErrored(true));
    //   dispatch(CardUIsaveIsLoading(false));
    // });
  };
}

export function adjustCard() {
  return (dispatch, getState) => {
    setExpandAll(getState().chapterContentData.slice());
    let indexProject = getState().projectData.findIndex(
      (x) => x.proj_id === getState().selectedProjectID
    );
    let margins = JSON.parse(getState().projectData[indexProject].proj_profile)
      .layout.layout_margins;
    setLineSpacing(margins);
  };
}

export function addNewRow(row, type) {
  return (dispatch, getState) => {
    let rowsArray = getState().chapterRowsData.slice();
    rowsArray.splice(row, 0, { times: 1, type, row: 0, page: false });
    dispatch(chapterRowsDataFetchDataSuccess(rowsArray));
  };
}

export function editRow(row, action) {
  return (dispatch, getState) => {
    let rowsArray = getState().chapterRowsData.slice();
    if (action === "add" && row !== 0) {
      rowsArray[row].times++;
    } else if (action === "subtract" && rowsArray[row].times > 1 && row !== 0) {
      rowsArray[row].times--;
    } else if (action === "page" && row > 0) {
      rowsArray[row].page = !rowsArray[row].page;
    }
    dispatch(chapterRowsDataFetchDataSuccess(rowsArray));
  };
}

export function deleteRow(index) {
  return (dispatch, getState) => {
    let rowsArray = getState().chapterRowsData.slice();
    if (rowsArray.length > 1) {
      if (rowsArray[index + 1] && rowsArray[index].page) {
        rowsArray[index + 1].page = true;
      }
      rowsArray.splice(index, 1);
      dispatch(chapterRowsDataFetchDataSuccess(rowsArray));
    }
  };
}

export function handleWatermark(watermark, reset = false) {
  return (dispatch, getState) => {
    let localCards = JSON.parse(JSON.stringify(getState().chapterContentData));
    let index = getState().CardUINavbarCard.id;

    // TODO: DELETE WHEN OLD CHAPTER COMPLETELY DELETE
    if (!localCards[index].watermark) {
      localCards[index].watermark = {
        negazione: false,
        plurale: false,
        passato: false,
        futuro: false,
      };
    }

    if (reset === false) {
      if (watermark === "futuro") {
        localCards[index].watermark["passato"] = false;
      } else if (watermark === "passato") {
        localCards[index].watermark["futuro"] = false;
      }

      localCards[index].watermark[watermark] = !localCards[index].watermark[
        watermark
      ];
    } else {
      Object.keys(localCards[index].watermark).forEach(
        (key) => (localCards[index].watermark[key] = false)
      );
    }

    dispatch(CardUINavbarCard(localCards[index]));
    dispatch(chapterContentDataFetchDataSuccess(localCards));
  };
}

export function CardUIsaveIsCompleted(isCompleted) {
  return (dispatch) => {
    dispatch({
      type: CARDUI_SAVE_PROJECT_COMPLETED,
      isCompleted,
    });
  };
}

export function CardUIsaveHasErrored(hasErrored) {
  return (dispatch) => {
    dispatch({
      type: CARDUI_SAVE_PROJECT_ERROR,
      hasErrored,
    });
  };
}

export function CardUIsaveIsLoading(isLoading) {
  return (dispatch) => {
    dispatch({
      type: CARDUI_SAVE_PROJECT_LOADING,
      isLoading,
    });
  };
}

export function CardUIsearchIsLoading(isLoading) {
  return (dispatch) => {
    dispatch({
      type: CARDUI_SEARCH_ISLOADING,
      isLoading,
    });
  };
}

export function CardUIcopyPaste(card) {
  return (dispatch) => {
    dispatch({
      type: CARDUI_COPYPASTE,
      card,
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/CardUIActions.js